/* eslint-disable @typescript-eslint/naming-convention */
import { Component, OnInit, ViewChild } from "@angular/core";
import { FormControl, FormGroup } from "@angular/forms";
import { MatDialog, MatDialogRef } from "@angular/material/dialog";
import { Router } from "@angular/router";
import { AuthenticationService } from "../../../core/authentication/authentication.service";
import { LoadingService } from "../../../core/loader/loading.service";
import { DataTableComponent } from "../../../shared/components/data-table/data-table.component";
import { DataTable } from "../../../shared/components/data-table/data-table.type";
import { DeleteModalComponent } from "../../../shared/components/delete-modal/delete-modal.component";
import { NotificationService } from "../../../shared/components/notification/notification.service";
import { SearchFilterOption } from "../../../shared/components/search-bar/search-filter/search-filter.component";
import { UserInfo } from "../../../shared/types/user-info";
import { getAssetActions } from "./asset";
import { AssetTableService } from "./asset-table.service";
import { AssetService } from "./asset.service";
import { Asset } from "./asset.type";

@Component({
  selector: "app-assets",
  templateUrl: "./assets.component.html",
  styleUrls: ["./assets.component.scss"],
})
export class AssetsComponent implements OnInit {
  @ViewChild("table") table: DataTableComponent<Asset>;
  tableConfig: DataTable<Asset>;
  currentUser: UserInfo;
  selectedAction: SearchFilterOption;
  additionalInformation: string;
  form = new FormGroup({
    assets_page: new FormControl(),
    assets_pageSize: new FormControl(),
  });
  assetActions: SearchFilterOption[];

  constructor(
    public dialog: MatDialog,
    public dialogRef: MatDialogRef<DeleteModalComponent>,
    public assetTableService: AssetTableService,
    public notificationService: NotificationService,
    private router: Router,
    private authenticationService: AuthenticationService,
    private loader: LoadingService,
    private assetService: AssetService,
  ) {
    this.currentUser = this.authenticationService.currentUserInfo;
  }

  // #region Life cycle method

  ngOnInit(): void {
    this.assetActions = getAssetActions();

    const hidden = ["dmr", "monitoring"];
    if (!this.currentUser.isGlobal()) {
      hidden.push("fairMarketValue", "bookValue");
    }
    this.tableConfig = this.assetTableService.getAssetsTableConfig({
      syncWithQueryParams: true,
      selection: { hidden: false },
      hidden: hidden,
    });
  }

  // #endregion

  // #region Validators

  isSendActionEnabled = (): boolean => {
    return !(this.selectedAction && this.additionalInformation && this.table?.getSelectedRows()?.length);
  };
  // #endregion

  // #region Handlers

  onAddAsset(): void {
    this.addAsset();
  }

  onSendAction(): void {
    this.sendAction();
  }
  // #endregion

  // #region Private methods

  private addAsset(): void {
    this.router.navigate(["/assets/create"]);
  }

  private sendAction(): void {
    const assetIds = this.table?.getSelectedRows().reduce((arr, elem) => (arr.push(elem.id), arr), []);
    const data = {
      action: this.selectedAction.value,
      assetIds,
      additionalInformation: this.additionalInformation,
    };

    this.assetService
      .actionRequest(data)
      .subscribe(
        () => {
          this.notificationService.success("Action requested correctly");
          this.table.resetSelectedRows(true);
        },
        (err) => {
          const error = `Action could not be requested:\n ${err}`;
          this.notificationService.error(error);
        },
      )
      .add(() => {
        this.loader.hide();
      });
  }
  // #endregion
}
